import { useFormContext } from 'react-hook-form';

import Title from 'src/refactor_components/common/Title';
import { FileUpload } from 'src/refactor_shared/ui/FileUpload';

const GymAddBasic = () => {
  const methods = useFormContext();
  return (
    <>
      <div className="flex flex-col gap-8 items-start">
        <Title essential text="장소명" />
        <input
          {...methods.register('name')}
          className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
          placeholder={'장소명을 입력해주세요'}
        />
      </div>

      <div className="flex flex-col gap-8 items-start">
        <Title text="전화번호" />
        <input
          {...methods.register('phone')}
          className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
          placeholder={'해당 장소의 전화번호를 입력해주세요'}
        />
      </div>

      <div className="flex flex-col gap-8 items-start">
        <Title text="사진 업로드" />
        <FileUpload
          registerName={'images'}
          maxCount={5}
          path="exercise-image"
        />
      </div>

      <div className="flex flex-col gap-8 items-start">
        <Title text="추가 정보">
          <p className="text-[14px] text-[#9170F2]">최대 500자</p>
        </Title>
        <textarea
          {...methods.register('introduction')}
          className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] placeholder:text-[#999] border border-solid border-[var(--color-gray-second)] h-160"
          placeholder={
            '수업 장소에 대해 추가적으로 안내할 사항에 대해 작성해주세요'
          }
        />
      </div>
    </>
  );
};

export default GymAddBasic;
